import { AdditionalApi, FeedbackApi } from 'api';
import { AdditionalQuery, FeedbackQuery } from 'queries';
import { useMemo, useState } from 'react';
import { IAdditional, IFeedback, IQuestion, QuestionType } from 'types';

interface Props {
  load: (title?: string, questions?: IQuestion[]) => void;
  type: QuestionType;
}

function useLoadForms({ load, type }: Props) {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const { data: additionalData } = AdditionalQuery.useGetAll(
    {
      page: 1,
      size: 100,
    },
    type === 'additional' && isOpenModal,
  );

  const { data: feedbackData } = FeedbackQuery.useGetAll(
    {
      page: 1,
      size: 100,
    },
    type === 'feedback' && isOpenModal,
  );

  const data: (IAdditional | IFeedback)[] = useMemo(() => {
    if (type === 'additional') return additionalData?.data || [];
    if (type === 'feedback') return feedbackData?.data || [];
  }, [additionalData, feedbackData]);

  const handleSelect = async (data: IAdditional | IFeedback) => {
    try {
      const res = await (type === 'additional'
        ? AdditionalApi.get(String(data.id))
        : FeedbackApi.get(String(data.id)));

      load(res.data.title, res.data.questions);
      setIsOpenModal(false);
    } catch {
      return;
    }
  };

  const handleOpen = () => {
    setIsOpenModal(true);
  };

  const handleClose = () => {
    setIsOpenModal(false);
  };

  return {
    data,
    isOpenModal,
    setIsOpenModal,
    handleClose,
    handleOpen,
    handleSelect,
  };
}

export default useLoadForms;
